import React from 'react';
import { Link } from 'react-router-dom';
import bulovaLogo from '../assets/watches/Bulova.png';
import citizenLogo from '../assets/watches/Citizen.png';
import seikoLogo from '../assets/watches/Seiko.png';
import tissotLogo from '../assets/watches/Tissot.png';

const Watches = () => {
  const watchBrands = [
    {
      name: 'Bulova',
      logo: bulovaLogo,
      description: 'Precision timekeeping with innovative technology and elegant design.',
      specialties: ['Precisionist', 'Marine Star', 'Dress Watches']
    },
    {
      name: 'Citizen',
      logo: citizenLogo,
      description: 'Eco-Drive solar technology and superior craftsmanship.',
      specialties: ['Eco-Drive', 'Promaster', 'Satellite Wave']
    },
    {
      name: 'Seiko',
      logo: seikoLogo,
      description: 'Japanese excellence in mechanical and quartz movements.',
      specialties: ['Prospex', 'Presage', 'Kinetic']
    },
    {
      name: 'Tissot',
      logo: tissotLogo,
      description: 'Swiss tradition with cutting-edge innovation since 1853.',
      specialties: ['T-Touch', 'PRC 200', 'Seastar']
    }
  ];

  return (
    <section id="watches" className="py-24 px-6 bg-white relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0">
        <div className="absolute top-20 left-10 w-64 h-64 bg-gold-100 rounded-full opacity-10 animate-float"></div>
        <div className="absolute bottom-20 right-10 w-48 h-48 bg-gold-100 rounded-full opacity-10 animate-float" style={{ animationDelay: '2s' }}></div>
      </div>

      <div className="max-w-7xl mx-auto relative">
        <div className="text-center mb-16">
          <span className="font-montserrat text-xs tracking-super-wide text-gold-600 uppercase">Timepiece Collection</span>
          <h2 className="font-playfair text-5xl md:text-6xl text-charcoal mt-4 mb-6">
            Watch Brands We Carry
          </h2>
          <div className="w-24 h-px bg-gradient-gold mx-auto"></div>
          <p className="font-cormorant text-xl text-charcoal/70 max-w-3xl mx-auto mt-6">
            From precision sports watches to elegant dress timepieces, discover our curated selection of world-renowned brands
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {watchBrands.map((brand, index) => (
            <div
              key={brand.name}
              className="group bg-cream p-8 hover:bg-white transition-all duration-500 hover:shadow-2xl hover:-translate-y-2"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              {/* Brand Logo */}
              <div className="h-20 flex items-center justify-center mb-6 overflow-hidden">
                <img
                  src={brand.logo}
                  alt={`${brand.name} logo`}
                  className="max-h-full max-w-full object-contain filter grayscale group-hover:grayscale-0 transition-all duration-500"
                />
              </div>

              {/* Brand Name */}
              <h3 className="font-playfair text-2xl text-charcoal text-center mb-4 group-hover:text-gold-600 transition-colors duration-300">
                {brand.name}
              </h3>

              {/* Description */}
              <p className="font-montserrat text-sm text-charcoal/70 text-center mb-6 leading-relaxed">
                {brand.description}
              </p>


              {/* Hover effect border */}
              <div className="absolute inset-0 border-2 border-gold-400 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"></div>
            </div>
          ))}
        </div>

        {/* Call to Action */}
        <div className="bg-gradient-to-r from-charcoal to-charcoal/90 p-12 text-center relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-r from-gold-900/20 via-gold-600/10 to-gold-900/20"></div>
          <div className="relative">
            <h3 className="font-playfair text-3xl text-white mb-4">
              Expert Watch Services
            </h3>
            <p className="font-cormorant text-xl text-white/80 mb-8 max-w-2xl mx-auto">
              From battery replacements to complete overhauls, we provide professional service for all major brands
            </p>
            <div className="flex justify-center">
              <Link to="/repair-estimate" className="px-8 py-4 border-2 border-white/50 text-white font-montserrat text-sm tracking-wider hover:border-gold-400 hover:text-gold-400 transition-all duration-300 inline-block text-center">
                SCHEDULE SERVICE
              </Link>
            </div>
          </div>
        </div>

        {/* Services highlight */}
        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="text-center p-6">
            <div className="w-16 h-16 bg-gradient-gold rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="text-2xl text-white">🔧</span>
            </div>
            <h4 className="font-playfair text-xl text-charcoal mb-3">Expert Repairs</h4>
            <p className="font-montserrat text-sm text-charcoal/70">
              We service all major watch brands and movements
            </p>
          </div>
          <div className="text-center p-6">
            <div className="w-16 h-16 bg-gradient-gold rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="text-2xl text-white">⚡</span>
            </div>
            <h4 className="font-playfair text-xl text-charcoal mb-3">While You Wait</h4>
            <p className="font-montserrat text-sm text-charcoal/70">
              Most battery replacements and minor repairs completed in 15-30 minutes
            </p>
          </div>
          <div className="text-center p-6">
            <div className="w-16 h-16 bg-gradient-gold rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="text-2xl text-white">🛡️</span>
            </div>
            <h4 className="font-playfair text-xl text-charcoal mb-3">Warranty Protected</h4>
            <p className="font-montserrat text-sm text-charcoal/70">
              All watch services backed by our comprehensive warranty program
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Watches;